import React, { Component } from 'react';
import * as QueryString from 'query-string';
import { Row, Col, Container, Image } from 'react-bootstrap';

import { Http } from '../../support';
import Uuid from '../../support/Uuid';
import ByPactopia from '../../app/auth/ByPactopia';
import Loading from '../../facturotopia/loading/Loading';
import LoadingButton from '../../facturotopia/LoadingButton';
import ResponseError from '../../shared/responses/ResponseError';
import ResponseResult from '../../shared/responses/ResponseResult';
import InfoDataOnTicketStamping from './components/InfoDataOnTicketStamping';
import TimbradoTicketRequestSearch from './components/TimbradoTicketRequestSearch';
import AdditionalDataOnTicketStamping from './components/AdditionalDataOnTicketStamping';
import TotalGlobalSummary from '../../app/comprobantes/create/components/TotalGlobalSummary';
import ReceptorFiscalInfoForm from '../../app/receptores/upsert/components/ReceptorFiscalInfoForm';
import CreateReceptorAccountOnTicketStamping from './components/CreateReceptorAccountOnTicketStamping';
import ConceptosNotEditableList from '../../app/comprobantes/create/components/conceptos/ConceptosNotEditableList';

class TimbradoTicketRequest extends Component {
  state = {};

  cache = null;
  timer = null;

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      busy: false,
      error: null,
      loading: false,
      fetching: false,
      downloaded: false,
    };
  }

  componentDidMount() {
    const { location } = this.props;

    if (!!location) {
      this.getBussinesRules();
    }
  }

  getBussinesRules = async () => {
    this.setState({
      loading: true,
    });

    const query = QueryString.parse(this.props.location.search);

    const headers = {
      'X-Tenancy': query.tenancy,
    };

    const params = {
      origin: window.location.origin,
    };

    try {
      const response = await Http.get('api/autofacturacion/referer', { params, headers });

      this.setState({
        loading: false,
        logo: response.data.logo,
        landing_info: response.data.landing_info,
        landing_form: response.data.landing_form,
        timbrado_form: response.data.timbrado_form,
      });
    } catch (error) {
      this.setState({
        loading: false,
        error: error.data || error,
      });
    }
  };

  get rules() {
    return {
      codigo: ['required', 'max:255'],
    };
  }

  get inputs() {
    return {
      key: {
        name: 'codigo',
        label: 'Código',
      },
    };
  }

  onReceptorFormDataChange = (event) => {
    const {
      data,
      data: { input = {} },
    } = this.state;

    const state = {
      data: {
        ...data,
        input: {
          ...input,
          Receptor: {
            ...event.data,
          },
        },
      },
      isValid: event.isValid,
    };

    this.setState({
      ...state,
    });

    const rfc = state.data.input.Receptor.rfc;

    if (!!rfc && !!rfc.trim() && rfc !== this.cache) {
      if (rfc.length >= 12 && ['XAXX010101000', 'XEXX010101000'].indexOf(rfc) === -1) {
        if (this.timer) {
          clearTimeout(this.timer);
        }

        this.timer = setTimeout(async () => {
          this.setState({
            fetching: true,
          });

          try {
            const query = QueryString.parse(this.props.location.search);

            const headers = {
              'X-Tenancy': query.tenancy,
            };

            const params = {
              rfc,
              tickets: state.data.input.tickets,
            };

            const response = await Http.get('/ext/receptores/autofacturacion/perfil', { params, headers });

            const {
              data,
              data: { input = {} },
            } = this.state;

            const newState = {
              data: {
                ...data,
                input: {
                  ...input,
                  Receptor: {
                    ...response,
                    cp: response.direccion?.cp,
                  },
                },
              },
            };

            this.setState({
              isValid: true,
              ...newState,
            });
          } catch (error) {
          } finally {
            this.setState({
              fetching: false,
            });
          }
        }, 1000);
      }

      this.cache = rfc;
    }
  };

  handleOnSearchSuccess = (data) => {
    this.setState({
      data: {
        ...this.state.data,
        input: {
          ...data,
          Receptor: {
            uso_cfdi: 'G03',
          },
        },
      },
    });
  };

  submit = async () => {
    const {
      data: { input },
    } = this.state;

    this.setState({
      busy: true,
    });

    try {
      const params = QueryString.parse(this.props.location.search);

      const headers = {
        'X-Tenancy': params.tenancy,
      };

      const body = {
        ...input,
        Receptor: {
          Rfc: input.Receptor.rfc,
          Nombre: input.Receptor.razon_social,
          Email: input.Receptor.email,
          Regimen: input.Receptor.regimen,
          CP: input.Receptor.cp,
          UsoCFDI: input.Receptor.uso_cfdi,
          External: input.Receptor.external,
        },
      };

      const response = await Http.post(`api/autofacturacion/facturas`, body, { headers });

      this.setState({
        busy: false,
        result: response,
      });
    } catch (error) {
      this.setState({
        error: error.data || error,
        busy: false,
      });
    }
  };

  handleOnAction = () => {
    const { result } = this.state;

    window.location = result.data.link;

    this.setState({
      downloaded: true,
    });
  };

  handleResetError = () => {
    this.setState({
      error: undefined,
    });
  };

  handleOnDone = () => {
    this.setState({
      data: {},
      result: undefined,
      error: undefined,
      downloaded: false,
    });
  };

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleResetError}
        />
      </div>
    );
  };

  renderResult = () => {
    const { result: _result, downloaded } = this.state;

    let result = {
      ..._result,
      message: _result.message + ' Si quieres descargar tu factura haz click en "Descargar"',
    };

    if (downloaded) {
      return (
        <div className="result-container">
          <ResponseResult
            title="Factura emitida."
            result={result}
            btnText="Continuar"
            onAction={this.handleOnDone}
          />
        </div>
      );
    }

    return (
      <div className="result-container">
        <ResponseResult
          title="Factura emitida."
          result={result}
          btnText="Descargar mi factura"
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  handleOnChange = (value) => {
    this.setState({
      ...this.state,
      isValidDataAdditional: value.isValid,
      data: {
        input: {
          ...this.state.data.input,
          FormaPago: value.FormaPago,
        },
      },
    });
  };

  render() {
    const {
      busy,
      loading,
      data: { input },
      error,
      result,
      logo,
      landing_info,
      landing_form = [],
      timbrado_form = [],
    } = this.state;

    let { isValid, isValidDataAdditional = true } = this.state;

    isValid = isValid && isValidDataAdditional;

    if (!!input && !!input.Conceptos && !!input.Conceptos.Concepto) {
      input.Conceptos.Concepto = input.Conceptos.Concepto.map((item) => {
        if (!item.id) {
          item = {
            ...item,
            id: Uuid.v4(),
          };
        }

        return item;
      });
    }

    if (loading) {
      return <Loading />;
    }

    return (
      <>
        <Container className={`external-wrapper`}>
          <Row className="pt-5">
            <Col
              md={6}
              sm={true}
            >
              <div className="pb-3">
                <strong className="text-info text-uppercase">Facturas On-Demand</strong>
              </div>
            </Col>
          </Row>

          {!!result && this.renderResult()}

          {!!error && this.renderError()}

          {!input && (
            <Row>
              <Col
                md={6}
                sm={true}
              >
                <div className="pb-3">
                  <TimbradoTicketRequestSearch
                    data={landing_form}
                    onSearchSuccess={this.handleOnSearchSuccess}
                  />
                </div>
              </Col>
              <Col
                md={6}
                sm={true}
                className="text-center"
              >
                {!!logo && (
                  <div className="text-center pt-0 mb-4">
                    <Image
                      width={150}
                      src={logo}
                    />
                  </div>
                )}

                {!landing_info && (
                  <>
                    Hola, para solicitar tu factura sigue los siguientes pasos:
                    <br />
                    <br />
                    1. Introduce el código proporcionado por el establecimiento.
                  </>
                )}

                {!!landing_info && <InfoDataOnTicketStamping data={this.state.landing_info ?? {}} />}
              </Col>
            </Row>
          )}

          {!!input && (
            <>
              <Row>
                <Col
                  md={6}
                  sm={true}
                  className="py-3"
                >
                  <div className="pb-3" translate="no">
                    {/* TODO: Set up datos_fiscales_requeridos for CFDI 4,0 */}
                    <ReceptorFiscalInfoForm
                      data={input.Receptor || {}}
                      autoFocus={true}
                      datos_fiscales_requeridos={true}
                      autofacturacion={true}
                      onFormDataChange={this.onReceptorFormDataChange}
                    />

                    <AdditionalDataOnTicketStamping
                      data={input}
                      bussines={timbrado_form}
                      onFormDataChange={this.handleOnChange}
                    />

                    {!!input.Receptor &&
                      !!input.Receptor.email &&
                      input.Receptor.rfc !== 'XAXX010101000' &&
                      input.Receptor.rfc !== 'XEXX010101000' && (
                        <CreateReceptorAccountOnTicketStamping
                          data={input.Receptor || {}}
                          isValid={isValid}
                          onFormDataChange={this.onReceptorFormDataChange}
                        />
                      )}
                  </div>
                </Col>

                <Col
                  md={6}
                  sm={true}
                  className="py-3"
                >
                  Hola, para solicitar tu factura sigue los siguientes pasos:
                  <br />
                  <br />
                  <s>1. Introduce el código proporcionado por el establecimiento.</s>
                  <br />
                  {!result && <span>2. Completa tu información fiscal.</span>}
                  {!!result && <s>2. Completa tu información fiscal.</s>}
                  <br />
                  {!!result && <span>3. Guarda tu factura, adicionalmente la recibirás por email.</span>}
                  <br />
                  {!result && (
                    <>
                      <p className="text-danger">
                        <strong>NOTA IMPORTANTE !!!</strong>
                      </p>

                      <p>
                        Para <strong>CFDI 4.0</strong> debes ingresar la razón social{' '}
                        <strong>sin régimen capital</strong>.
                        <br />
                        <br />
                        Ejemplo:
                        <br />
                        Razón Social: <span className="text-dark">MI RAZON SOCIAL S.A. DE C.V</span>
                        <br />
                        Debe usarse: <span className="text-dark">MI RAZON SOCIAL</span> (Omitir el: S.A. DE C.V)
                      </p>
                    </>
                  )}
                </Col>
              </Row>

              <Row>
                <Col
                  sm={12}
                  xs={true}
                  className="pb-5"
                >
                  <div className="pb-3">
                    <strong className="text-info">Conceptos</strong>
                  </div>

                  <ConceptosNotEditableList
                    data={!!input && !!input.Conceptos && !!input.Conceptos.Concepto ? input.Conceptos.Concepto : []}
                  />

                  <TotalGlobalSummary data={input} />

                  <LoadingButton
                    type="button"
                    disabled={!isValid}
                    loading={busy || false || !!result}
                    onClick={this.submit}
                  >
                    {busy ? 'Procesando...' : 'Facturar'}
                  </LoadingButton>
                </Col>
              </Row>
            </>
          )}
        </Container>

        <div className="pt-4 pb-4">
          <ByPactopia width={200} />
        </div>
      </>
    );
  }
}

export default TimbradoTicketRequest;
